import { EmbedMetadata } from '@modules/url-metadata/EmbedMetadata';
import { createEmbedExtension } from '../shared/createEmbedExtension';

export default createEmbedExtension({
  regexp: [
    /(https?:\/\/[^\s]+)/g,
    /(www\.[^\s]+)/g,
    /([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?/g,
  ],
  name: 'link-metadata-embed',
  component: EmbedMetadata,
  addCommandOption: {
    title: 'Link from web',
    description: 'Embed a link from the web.',
    searchTerms: ['embed', 'link'],
    icon: 'tabler:compass',
  },
});
